import { CompanionError } from '../../_internal/error/CompanionError';
import { cleanFilename } from '../../upload/util';
export const SUPPORTED_FILETYPES = [
    {
        value: 'mp4',
        mime: 'video/mp4',
        extensions: ['mp4'],
    },
    {
        value: 'webm',
        mime: 'video/webm',
        extensions: ['webm'],
    },
    {
        value: 'flv',
        mime: 'video/flash',
        extensions: ['flv'],
    },
    {
        value: 'aac',
        mime: 'audio/aac',
        extensions: ['aac', 'm4a', 'f4a'],
    },
    {
        // NEW!
        value: 'mpeg',
        mime: 'audio/mpeg',
        extensions: ['mpg', 'mp3'],
    },
    {
        // NEW!
        value: 'ogg',
        mime: 'audio/ogg',
        extensions: ['ogg'],
    },
    {
        value: 'm3u8',
        mime: 'application/vnd.apple.mpegurl',
        extensions: ['m3u8', 'm3u'],
    },
    {
        value: 'smil',
        mime: 'application/smil+xml',
        extensions: ['smil', 'smi', 'sml'],
    },
    {
        value: 'mpd',
        mime: 'application/dash+xml',
        extensions: ['mpd'],
    },
    // No longer included:
    // - m2t
    // - mts
];
/**
 *  This will verify the provided data (if required), and will modify the data to ensure everything is set correctly for upload
 */
export function validateURLData(data) {
    var _a, _b, _c;
    // Determine if we're dealing with URL saving/ upload:
    if (typeof ((_a = data.upload) === null || _a === void 0 ? void 0 : _a.method) === 'undefined' || !['fetch', 'external'].includes((_b = data.upload) === null || _b === void 0 ? void 0 : _b.method)) {
        return;
    }
    // Check if correct field is set for the chosen method:
    const index = data.upload.method === 'external' ? 'source_url' : 'download_url';
    const url = data.upload[index];
    if (typeof url === 'undefined') {
        throw new CompanionError({
            error: new Error(`'${index}' is required when method is '${data.upload.method}'`),
            code: 'MISSING_FIELD',
        });
    }
    // Verify the URL:
    const urlObj = typeof url === 'string' ? new URL(url) : url;
    data.upload[index] = urlObj.href; // Use the verified url
    // Try to guess the mime format:
    if (data.upload.method === 'external') {
        data.upload.mime_type = guessFormatFromURL(urlObj);
    }
    // Set a title default if none has been provided:
    data.metadata = Object.assign(Object.assign({}, data.metadata), { title: ((_c = data.metadata) === null || _c === void 0 ? void 0 : _c.title) || guessTitleFromURL(urlObj) });
}
validateURLData.ERR = {
    MISSING_FIELD: 'MISSING_FIELD',
};
export function guessTitleFromURL(url) {
    const parts = url.pathname.split('/');
    let fileName = parts[parts.length - 1];
    fileName = fileName === null || fileName === void 0 ? void 0 : fileName.replace(/\.[^/.]+$/, '');
    if (fileName) {
        fileName = cleanFilename(fileName); // Also strips the extension
    }
    return fileName || 'Untitled';
}
export function guessFormatFromURL(url) {
    var _a, _b;
    const parts = url.pathname.substr(1, url.pathname.length).split('.');
    const extension = (_a = parts[parts.length - 1]) !== null && _a !== void 0 ? _a : '';
    // Try to match based on extension:
    let fileType = (_b = SUPPORTED_FILETYPES.find((ext) => ext.extensions.includes(extension))) === null || _b === void 0 ? void 0 : _b.mime;
    if (!fileType) {
        // Set a default if no match found
        fileType = 'video/mp4';
    }
    return fileType;
}
